import { Action } from 'redux';
import { DiscountRuleFilters, DiscountRuleModel } from '../../../api/pricing/pricing.types';
import { Page } from '../../../api/api.types';

export const GET_DISCOUNT_RULES_LIST = 'GET_DISCOUNT_RULES_LIST';
export const GET_DISCOUNT_RULE = 'GET_DISCOUNT_RULE';
export const PUT_DISCOUNT_RULE = 'PUT_DISCOUNT_RULE';
export const POST_DISCOUNT_RULE = 'POST_DISCOUNT_RULE';
export const DELETE_DISCOUNT_RULE = 'DELETE_DISCOUNT_RULE';
export const UPDATE_DISCOUNT_RULE_FILTERS = 'UPDATE_DISCOUNT_RULE_FILTERS';

export interface DiscountRuleState {
  discountRules: DiscountRuleModel[] | [];
  selectedDiscountRule: DiscountRuleModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
  filters: DiscountRuleFilters | null;
}

export interface GetDiscountRulesListAction extends Action {
  type: typeof GET_DISCOUNT_RULES_LIST;
  payload: {
    page: Page<DiscountRuleModel>;
  };
}

export interface GetDiscountRuleAction extends Action {
  type: typeof GET_DISCOUNT_RULE;
  payload: {
    selectedDiscountRule: DiscountRuleModel | null;
  };
}

export interface PutDiscountRuleAction extends Action {
  type: typeof PUT_DISCOUNT_RULE;
  payload: {
    selectedDiscountRule: DiscountRuleModel;
  };
}

export interface PostDiscountRuleAction extends Action {
  type: typeof POST_DISCOUNT_RULE;
  payload: {
    newDiscountRule: DiscountRuleModel;
    success: boolean;
  };
}

export interface DeleteDiscountRuleAction extends Action {
  type: typeof DELETE_DISCOUNT_RULE;
  payload: {
    success: boolean;
  };
}

export interface UpdateDiscountRuleFiltersAction extends Action {
  type: typeof UPDATE_DISCOUNT_RULE_FILTERS;
  payload: {
    filters: DiscountRuleFilters;
  };
}

export type DiscountRuleActionTypes =
  GetDiscountRulesListAction
  | GetDiscountRuleAction
  | PutDiscountRuleAction
  | PostDiscountRuleAction
  | DeleteDiscountRuleAction
  | UpdateDiscountRuleFiltersAction;
